module.exports = __webpack_public_path__ + "app/images/36891_Abbott_Visuals_Website_v3-HMB.png";